export enum MathFuncEnum {
  ROUND = 'ROUND',
  ABS = 'ABS',
  CEIL = 'CEIL',
  FLOOR = 'FLOOR',
}

export class MathFuncModel {
  constructor(
    public target = '',
    public column = '',
    public func: MathFuncEnum = MathFuncEnum.ROUND,
    public value = 0,
  ) {}
}
